import {
  Backdrop,
  Box,
  Button,
  Fade,
  Grid,
  Modal,
  Typography,
} from "@mui/material"
import SaveIcon from "@mui/icons-material/Save"
import DeleteIcon from "@mui/icons-material/Delete"
import { useEffect, useState } from "react"

export const MyModal = ({
  updateTitle,
  insertTitle,
  isOpen,
  handleClose,
  style,
  selected,
  onSave,
  onDelete,
  children,
}) => {
  const defaultStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  }

  const handleClickSave = () => {
    if (!!window.confirm("Está a punto de guardar los cambios efectuados...")) {
      console.log(selected)
      onSave()
      handleClose()
    }
  }

  const handleClickDelete = () => {
    if (!!window.confirm("¿Esta segur@ de eliminar este elemento?")) {
      console.log(selected)
      onDelete()
      handleClose()
    }
  }

  if (!selected) return <div></div>

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <Box sx={!!style ? style : defaultStyle}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" component="h2" mb={3}>
              {!!selected.id ? (
                <span>{updateTitle}</span>
              ) : (
                <span>{insertTitle}</span>
              )}
            </Typography>
            <Typography
              variant="h6"
              component="h2"
              mb={3}
              sx={{ cursor: "pointer", color: "gray" }}
              onClick={handleClose}
            >
              &times;
            </Typography>
          </Grid>
          <Box maxHeight={650} overflow="auto" p={3}>
            {children}
          </Box>
          <Grid
            container
            spacing={2}
            justifyContent="flex-end"
            alignItems="center"
            mt={3}
          >
            {!!onDelete && (
              <Grid item>
                <Button
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  onClick={handleClickDelete}
                  color={"warning"}
                >
                  Eliminar
                </Button>
              </Grid>
            )}
            {!!onSave && (
              <Grid item>
                <Button
                  variant="contained"
                  startIcon={<SaveIcon />}
                  onClick={handleClickSave}
                >
                  Guardar
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      </Fade>
    </Modal>
  )
}
